import { render, staticRenderFns } from "./AdditionalReference.vue?vue&type=template&id=540f833a&scoped=true&"
import script from "./AdditionalReference.vue?vue&type=script&lang=js&"
export * from "./AdditionalReference.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalReference.vue?vue&type=style&index=0&id=540f833a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f833a",
  null
  
)

/* custom blocks */
import block0 from "./AdditionalReference.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports